import { render } from "./ViewDocument.vue?vue&type=template&id=062b23be&scoped=true"
import script from "./ViewDocument.vue?vue&type=script&lang=js"
export * from "./ViewDocument.vue?vue&type=script&lang=js"

import "./ViewDocument.vue?vue&type=style&index=0&id=062b23be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-062b23be"]])

export default __exports__